<div class="container fundraiser-wrapper" *ngIf="!isLoading">
  <div class="row">
    <div class="col-md-12">
      <div class="heading">
        {{fundraiser?.title}}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-8 pt-3 wrapper-card">
      <app-fundraiser-slider-img [isPreview]="true" [share]="false" [gallery]="fundraiser?.gallery" [basicInfo]="basicInfo" [isFOS]="isFos" [hasThumbs]="false" [slideType]="'leaderboard'" [shadow]="isMobile ? true : false"></app-fundraiser-slider-img>
      <app-about *ngIf="basicInfo?.social" [isPreview]="true" [about]="basicInfo?.social" [isFundraiserEnded]="isFundraiserEnded"
            [fundraiser]="fundraiser" [basicInfo]="basicInfo">
      </app-about>
    </div>
    <div class="col-md-4 fundraiser-details mt-4 mb-5">
      <app-amount-card [isPreview]="true" [goal]="fundraiser?.amount_requested" [raised]="fundraiser?.raised?.raised"
      [supporters]="fundraiser?.raised?.backers" [date]="fundraiser?.end_date" [currency]="currency"
      [isFundraiserEnded]="isFundraiserEnded" [fundraiser]="fundraiser" />
    </div>
  </div>
</div>
<div *ngIf="isLoading" class="d-flex justify-content-center align-items-center" style="min-height: 300px;">
  <mat-progress-spinner
    color="primary"
    mode="indeterminate"
    diameter="50">
  </mat-progress-spinner>
</div>